(function() {
    'use strict';

    angular
        .module('elogbooks.common.jobs.workflow')
        .controller('JobEditController', JobEditController);

    JobEditController.$inject = ['apiClient', '$state', 'messenger', 'jobResponse', 'formData', 'scopeData',
        '$q', 'userCollectionResponse', 'siteResourceResponse', 'userManager', 'siteRelationshipResponse',
        'jobGroupCollectionResponse', 'jobGroupRequired', 'chargeTypesCollectionResponse',
        'chargeTypeResponse', 'jobSettings', 'documentTypesCollectionResponse', 'documentTypeService', 'lodash', 'confirmationModal',
        '$translate'];

    function JobEditController(
        apiClient, $state, messenger, jobResponse, formData, scopeData,
        $q, userCollectionResponse, siteResourceResponse, userManager, siteRelationshipResponse,
        jobGroupCollectionResponse, jobGroupRequired, chargeTypesCollectionResponse, chargeTypeResponse, jobSettings,
        documentTypesCollectionResponse, documentTypeService, lodash, confirmationModal, $translate
    ) {

        var vm = this;
        vm.job = jobResponse;
        angular.extend(vm, scopeData);
        vm.data = formData;

        vm.submitDisabled = false;
        vm.canSubmit = true;
        vm.userReporterResponse = {};
        vm.userContactResponse = {};
        vm.isStatutory = (jobResponse.getLink('statutorytype')) ? true : false;
        vm.poRequired = false;
        vm.hasChargeType = false;
        vm.isReporterTenant = (jobResponse.reporter) ? jobResponse.reporter.isTenant : false;
        vm.isContactTenant = (jobResponse.siteContact) ? jobResponse.siteContact.isTenant : false;
        vm.canSeeTenants = siteResourceResponse.getLink('tenantLogging') !== null;
        vm.jobGroupChildSelectMandatory = jobSettings.jobGroupChildSelectMandatory;
        vm.requiredDocumentType = documentTypesCollectionResponse;
        vm.selectedRequiredDocumentTypes = [];
        vm.requireDocumentTypeWhenRaisingReactiveJob = jobSettings.requireDocumentTypeWhenRaisingReactiveJob;
        vm.siteRequiredDocumentTypeRequired = siteResourceResponse.excludeFromRequiringDocumentType;

        angular.forEach(jobResponse.requiredDocumentTypes.documentTypes, function(docType) {
            vm.selectedRequiredDocumentTypes.push(docType);
        });

        vm.originalApprovalDocTypes = extractApprovalDocTypes(vm.selectedRequiredDocumentTypes);

        if (jobResponse.type == "reactive" && !jobResponse.reporter.email) {
            vm.data.reporter.declineEmail = true;
        }

        if (jobResponse.type == "reactive" && !jobResponse.siteContact.email) {
            vm.data.siteContact.declineEmail = true;
        }

        vm.notifications = {
            reporter: {
                notifyOnCreate: !!(jobResponse.reporter && jobResponse.reporter.notifyOnCreate),
                notifyOnComplete: !!(jobResponse.reporter && jobResponse.reporter.notifyOnComplete)
            },
            contact: {
                notifyOnCreate: !!(jobResponse.siteContact && jobResponse.siteContact.notifyOnCreate),
                notifyOnComplete: !!(jobResponse.siteContact && jobResponse.siteContact.notifyOnComplete)
            }
        };

        vm.data.requiredDocumentTypes = {
            links: null
        }

        vm.submit = submitAction;
        vm.findPseudoUsers = findPseudoUsers;
        vm.unsetStatutory = unsetStatutory;
        vm.toggleDeclineEmail = toggleDeclineEmail;
        vm.changeReporterTenant = () => changeTenantGeneric('reporter');
        vm.changeContactTenant = () => changeTenantGeneric('contact');
        vm.removeDocumentType = removeDocumentType;

        vm.reporterChangeUser = () => changeUserGeneric('reporter');
        vm.reporterChangeRelationship = reporterChangeRelationship;
        vm.reporterPseudoUserSelected = reporterPseudoUserSelected;
        vm.selectAsOccupier = selectAsOccupier;

        vm.contactChangeUser = () => changeUserGeneric('contact');
        vm.contactChangeRelationship = contactChangeRelationship;
        vm.contactPseudoUserSelected = contactPseudoUserSelected;
        vm.changeChargeType = changeChargeType;
        vm.changeRequiredDocumentType = changeRequiredDocumentType;
        vm.toggleReporterManualEntry = () => toggleManualEntryGeneric('reporter');
        vm.toggleContactManualEntry = () => toggleManualEntryGeneric('contact');

        // ===== Helper data to reduce duplication (reporter/contact) =====
        const entityMeta = {
            reporter: {
                isTenantFlag: 'isReporterTenant',
                personKey: 'reporter',
                tenantKey: 'reporterTenant',
                linkUser: 'reporter',
                linkTenant: 'reporterTenant',
                selectedUserModel: 'selectedUserReporterModel',
                selectedTenantModel: 'selectedTenantReporterModel',
                selectedRelationshipModel: 'selectedReporterRelationshipModel',
                jobKey: 'reporter'
            },
            contact: {
                isTenantFlag: 'isContactTenant',
                personKey: 'siteContact',
                tenantKey: 'contactTenant',
                linkUser: 'contact',
                linkTenant: 'contactTenant',
                selectedUserModel: 'selectedUserContactModel',
                selectedTenantModel: 'selectedTenantContactModel',
                selectedRelationshipModel: 'selectedContactRelationshipModel',
                jobKey: 'siteContact'
            }
        };

        // Helper function to wrap API calls with the loading indicator
        function withLoading(work) {
            vm.submitDisabled = true;

            return $q.when().then(work).finally(() => {
                vm.submitDisabled = false;
            });
        }

        vm.selectedJobGroupModel = {
            response: jobGroupCollectionResponse,
            link: jobGroupCollectionResponse.getLink('self'),
            required: jobGroupRequired,
            responseKeyPath: 'jobgroups',
            itemHrefPath: '_links.self.href',
            itemValuePath: 'name',
            isHierarchical: true
        };

        if(jobResponse.type == "reactive" && jobResponse.getLink('jobgroup')) {
            vm.selectedJobGroupModel.selected = jobResponse._links.jobgroup;
            vm.data._links['jobgroup'] = jobResponse._links.jobgroup;
        }

        vm.selectedUserReporterModel = {
            response: userCollectionResponse,
            link: userManager.user.getLink('users'),
            linkParameters: { 'site': siteResourceResponse.getData().id, status: 'active' },
            required: false,
            responseKeyPath: 'users',
            itemHrefPath: '_links.self.href',
            itemValuePath: 'name',
            onSelect: vm.reporterChangeUser,
            onRemove: vm.reporterChangeUser,
            disabled: false
        };

        if (jobResponse.type == "reactive" && jobResponse.reporter._links && jobResponse.reporter.getLink('user')) {
            vm.selectedUserReporterModel.selected = {
                object: jobResponse.reporter,
                href: jobResponse.reporter.getLink('user'),
                value: jobResponse.reporter.name
            };
            vm.data._links['reporter'] = jobResponse.reporter._links.user;
            changeUserGeneric('reporter', true);
        }

        vm.selectedReporterRelationshipModel = {
            response: siteRelationshipResponse,
            link: siteRelationshipResponse.getLink('self'),
            required: true,
            responseKeyPath: 'siterelationships',
            itemHrefPath: '_links.self.href',
            itemValuePath: 'name',
            onSelect: vm.reporterChangeRelationship,
            onRemove: vm.reporterChangeRelationship,
        };
        if (jobResponse.type == "reactive" && jobResponse.reporter._links && jobResponse.reporter.getLink('relationship')) {
            vm.selectedReporterRelationshipModel.selected = jobResponse.reporter._links.relationship;
            vm.data._links['reportersiterelationship'] = jobResponse.reporter._links.relationship;
        }

        vm.selectedUserContactModel = {
            response: userCollectionResponse,
            link: userManager.user.getLink('users'),
            linkParameters: { 'site': siteResourceResponse.getData().id, status: 'active' },
            required: false,
            responseKeyPath: 'users',
            itemHrefPath: '_links.self.href',
            itemValuePath: 'name',
            onSelect: vm.contactChangeUser,
            onRemove: vm.contactChangeUser,
            disabled: false
        };

        if (jobResponse.type == "reactive" && jobResponse.siteContact._links && jobResponse.siteContact.getLink('user')) {
            vm.selectedUserContactModel.selected = {
                object: jobResponse.siteContact,
                href: jobResponse.siteContact.getLink('user'),
                value: jobResponse.siteContact.name
            };
            vm.data._links['contact'] = jobResponse.siteContact._links.user;
            changeUserGeneric('contact', true);
        }

        vm.selectedTenantReporterModel = {
            response: userCollectionResponse,
            link: siteResourceResponse.getLink('tenantLogging'),
            linkParameters: {'site': siteResourceResponse.getData().id, 'order': 'name', status: 'active' },
            responseKeyPath: 'contacts',
            itemHrefPath: '_links.self.href',
            itemValuePath: 'nameAndCompany',
            onSelect: vm.changeReporterTenant,
            onRemove: vm.changeReporterTenant,
            disabled: false
        };

        if (jobResponse.type === "reactive" && vm.isReporterTenant && jobResponse.reporter._links) {
            vm.data.reporterTenant = jobResponse.reporter;

            vm.selectedTenantReporterModel.selected = {
                object: jobResponse.reporter,
                href: jobResponse.reporter.getLink('self'),
                value: jobResponse.reporter.name
            };

            vm.data.reporter = null;
            vm.data._links.reporterTenant = jobResponse.reporter.getLink('self');

            changeTenantGeneric('reporter', true);
        }

        vm.selectedTenantContactModel = {
            response: userCollectionResponse,
            link: siteResourceResponse.getLink('tenantLogging'),
            linkParameters: { 'site': siteResourceResponse.getData().id, 'order': 'name', status: 'active' },
            responseKeyPath: 'contacts',
            itemHrefPath: '_links.self.href',
            itemValuePath: 'nameAndCompany',
            onSelect: vm.changeContactTenant,
            onRemove: vm.changeContactTenant,
            disabled: false
        };

        if (jobResponse.type === "reactive" && vm.isContactTenant && jobResponse.siteContact._links ) {
            vm.data.contactTenant = jobResponse.siteContact;

            vm.selectedTenantContactModel.selected = {
                object: jobResponse.siteContact,
                href: jobResponse.siteContact.getLink('self'),
                value: jobResponse.siteContact.name
            };

            vm.data.siteContact = null;
            vm.data._links.contactTenant = jobResponse.siteContact.getLink('self');

            changeTenantGeneric('contact', true);
        }

        vm.selectedChargeTypeModel = {
            response: chargeTypesCollectionResponse,
            required: true,
            responseKeyPath: 'chargetypes',
            itemHrefPath: '_links.self.href',
            itemValuePath: 'name',
            onSelect: vm.changeChargeType,
            onRemove: vm.changeChargeType
        };

        if (chargeTypesCollectionResponse.chargetypes.length > 0) {
            vm.hasChargeType = true;
        }

        if (chargeTypeResponse) {
            vm.selectedChargeTypeModel.selected = {
                href : chargeTypeResponse._links.self,
                value : chargeTypeResponse.name
            };
            vm.changeChargeType();
        }

        vm.selectedContactRelationshipModel = {
            response: siteRelationshipResponse,
            link: siteRelationshipResponse.getLink('self'),
            required: true,
            responseKeyPath: 'siterelationships',
            itemHrefPath: '_links.self.href',
            itemValuePath: 'name',
            onSelect: vm.contactChangeRelationship,
            onRemove: vm.contactChangeRelationship
        };

        if (jobResponse.type == "reactive" && jobResponse.siteContact._links && jobResponse.siteContact.getLink('relationship')) {
            vm.selectedContactRelationshipModel.selected = jobResponse.siteContact._links.relationship;
            vm.data._links['sitecontactsiterelationship'] = jobResponse.siteContact._links.relationship;
        }

        vm.reporterManualEntry = (!vm.isReporterTenant && !(jobResponse.reporter && jobResponse.reporter._links && jobResponse.reporter.getLink('user')));
        vm.contactManualEntry = (!vm.isContactTenant && !(jobResponse.siteContact && jobResponse.siteContact._links && jobResponse.siteContact.getLink('user')));

        vm.selectedUserReporterModel.disabled = vm.reporterManualEntry;
        vm.selectedTenantReporterModel.disabled = vm.reporterManualEntry;
        vm.selectedUserContactModel.disabled = vm.contactManualEntry;
        vm.selectedTenantContactModel.disabled = vm.contactManualEntry;

        // Dynamically require selection when manual entry is NOT selected (either User or Tenant)
        vm.selectedUserReporterModel.required = !vm.reporterManualEntry;
        vm.selectedTenantReporterModel.required = !vm.reporterManualEntry;
        vm.selectedUserContactModel.required = !vm.contactManualEntry;
        vm.selectedTenantContactModel.required = !vm.contactManualEntry;

        vm.selectedRequiredDocumentTypeModel = {
            response: documentTypesCollectionResponse,
            required: false,
            responseKeyPath: 'documentTypes',
            itemHrefPath: '_links.self.href',
            itemValuePath: 'name',
            linkParameters: {status: 'active'},
            onSelect: changeRequiredDocumentType,
            onRemove: changeRequiredDocumentType,
        };

        if (jobResponse.getLink('required-document-type')) {
            vm.selectedRequiredDocumentTypeModel.selected = {
                href: jobResponse.getLink('required-document-type'),
                value: jobResponse.getLinkAttribute('required-document-type', 'title')
            };
        }

        function removeDocumentType(documentType) {
            documentTypeService.removeDocumentType(vm, documentType);
        }

        vm.certificateRequiredDocType = null;
        angular.forEach(vm.requiredDocumentType.documentTypes, function (value) {
            if (value.name === 'Certificate') {
                vm.certificateRequiredDocType = value;
            }
        });

        function changeRequiredDocumentType() {
            documentTypeService.changeRequiredDocumentType(vm);
        }


        function toggleDeclineEmail(jobCallerContact, type) {
            if (jobCallerContact.declineEmail) {
                jobCallerContact.email = null;
                jobCallerContact.notifyOnCreate = false;
                jobCallerContact.notifyOnComplete = false;

                if (type && vm.notifications[type]) {
                    vm.notifications[type].notifyOnCreate = false;
                    vm.notifications[type].notifyOnComplete = false;
                }
            }
        }

        function findPseudoUsers(name) {
            return withLoading(apiClient.get(siteResourceResponse.getLink('pseudousers'), {name: name})
                .then(function(response) {
                    return response['site-pseudo-users'];
                }, function(error) {
                    console.log(error);
                }));
        }


        function unsetStatutory() {
            delete vm.data._links.statutorytype;

            if (vm.certificateRequiredDocType) {
                removeDocumentType(vm.certificateRequiredDocType);
            }
        }

        function selectAsOccupier($type) {
            var model = null;
            switch ($type){
                case 'reporter':
                    model = vm.selectedReporterRelationshipModel;
                    break;
                case 'contact':
                    model = vm.selectedContactRelationshipModel;
                    break;
            }


            if (model) {
                model.selected = siteRelationshipResponse.siterelationships
                    .filter(function (item) {
                        return item.name === 'Occupier';
                    }).map(function(response){
                        return {
                            href:response._links.self.href,
                            obj:response,
                            value:response.name
                        };
                    })[0];
            }
        }

        function contactPseudoUserSelected(item) {
            vm.data.siteContact.name = item.name;
            vm.data.siteContact.email = item.email;
            vm.data.siteContact.phone = item.phone;
            vm.data.siteContact.notifyOnCreate = item.notifyOnCreation;
            vm.data.siteContact.notifyOnComplete = item.notifyOnCompletion;
            vm.notifications.contact.notifyOnCreate = !!item.notifyOnCreation;
            vm.notifications.contact.notifyOnComplete = !!item.notifyOnCompletion;

            var pseudoUserSiteRelationship = siteRelationshipResponse.siterelationships.find(function(elem) {
                return elem.getLink('self') === item.getLink('site-relationship');
            });

            vm.selectedContactRelationshipModel.selected = {
                object: pseudoUserSiteRelationship,
                href: pseudoUserSiteRelationship.getLink('self'),
                value: pseudoUserSiteRelationship.name
            };

            contactChangeRelationship();
        }

        function contactChangeRelationship() {
            if (vm.selectedContactRelationshipModel.selected && vm.selectedContactRelationshipModel.selected.object) {
                vm.selectedContactRelationship = vm.selectedContactRelationshipModel.selected.object;
                vm.data._links.sitecontactsiterelationship = {href: vm.selectedContactRelationship.getLink('self')};
            } else {
                vm.data._links.sitecontactsiterelationship = null;
            }
        }

        function reporterPseudoUserSelected(item) {
            vm.data.reporter.name = item.name;
            vm.data.reporter.email = item.email;
            vm.data.reporter.phone = item.phone;
            vm.data.reporter.notifyOnCreate = item.notifyOnCreation;
            vm.data.reporter.notifyOnComplete = item.notifyOnCompletion;
            vm.notifications.reporter.notifyOnCreate = !!item.notifyOnCreation;
            vm.notifications.reporter.notifyOnComplete = !!item.notifyOnCompletion;

            var pseudoUserSiteRelationship = siteRelationshipResponse.siterelationships.find(function(elem) {
                return elem.getLink('self') === item.getLink('site-relationship');
            });

            vm.selectedReporterRelationshipModel.selected = {
                object: pseudoUserSiteRelationship,
                href: pseudoUserSiteRelationship.getLink('self'),
                value: pseudoUserSiteRelationship.name
            };

            reporterChangeRelationship();
        }

        function reporterChangeRelationship() {
            if (vm.selectedReporterRelationshipModel.selected && vm.selectedReporterRelationshipModel.selected.object) {

                vm.selectedReporterRelationship = vm.selectedReporterRelationshipModel.selected.object;
                vm.data._links.reportersiterelationship = vm.selectedReporterRelationship.getLink('self');
            } else {
                vm.data._links.reportersiterelationship = null;
            }
        }

        const buildPhones = (target, sourceResponse, prevPhone) => {
            target.phoneNumbers = [];
            let emailSet = !!target.email;

            if (sourceResponse && sourceResponse?.contactInformation?.fields?.length > 0) {
                angular.forEach(sourceResponse.contactInformation.fields, (value) => {
                    if (value.type === 'telephone') {
                        target.phoneNumbers.push({ value: value.value });
                    }
                    if (value.type === 'email' && !emailSet) {
                        target.email = value.value;
                        emailSet = true;
                    }
                });
            } else {
                target.phoneNumbers = [{ value: sourceResponse.phone }];
                if (!emailSet) {
                    target.email = sourceResponse.email;
                }
            }

            if (!target.phoneNumbers.length) {
                target.phone = null;
                return;
            }

            const available = target.phoneNumbers.map(p => p.value);

            if (prevPhone && available.indexOf(prevPhone) !== -1) {
                target.phone = prevPhone;
                return;
            }

            if (target.phone && available.indexOf(target.phone) !== -1) {
                return;
            }

            target.phone = available[0];
        };

        function hrefOf(link) {
            if (!link) {
                return null;
            }

            return typeof link === 'string' ? link : link.href;
        }

        function changeUserGeneric(type, isInit) {
            const m = entityMeta[type];
            const model = vm[m.selectedUserModel];
            const selected = model && model.selected;

            if (selected) {
                const prevPhone = (vm.data && vm.data[m.personKey] && vm.data[m.personKey].phone) || (vm.job && vm.job[m.jobKey] && vm.job[m.jobKey].phone);
                const isSameUser = hrefOf(vm.data && vm.data._links && vm.data._links[m.linkUser]) === hrefOf(selected.href);

                return withLoading(() => apiClient.get(selected.href).then((response) => {
                    if (!isInit && !isSameUser) {
                        vm.data[m.personKey] = response;

                        if (type === 'reporter') {
                            vm.userReporterResponse = response;
                        } else {
                            vm.userContactResponse = response;
                        }
                    }

                    buildPhones(vm.data[m.personKey], response, prevPhone);

                    vm.data._links[m.linkUser] = selected.href;

                    // Clear tenant selection when user is chosen
                    if (vm[m.selectedTenantModel]) {
                        vm[m.selectedTenantModel].selected = null;
                    }

                    vm[m.isTenantFlag] = false;
                    vm.data[m.tenantKey] = null;
                    delete vm.data._links[m.linkTenant];
                }));
            } else {
                if (vm.data && vm.data._links) {
                    vm.data._links[m.linkUser] = null;
                }

                vm.data[m.personKey] = null;
                return $q.when();
            }
        }

        function changeTenantGeneric(type, isInit) {
            const m = entityMeta[type];
            const model = vm[m.selectedTenantModel];
            const selected = model && model.selected && model.selected.object ? model.selected.object : null;

            if (selected) {
                return withLoading(() => apiClient.get(selected.getLink('self')).then((response) => {
                    if (!vm.data[m.tenantKey] || vm.data[m.tenantKey].id != response.id) {
                        vm.data[m.tenantKey] = response;
                    }

                    vm.data._links[m.linkTenant] = selected.getLink('self');
                    const prevPhone = (vm.data && vm.data[m.tenantKey] && vm.data[m.tenantKey].phone) || (vm.job && vm.job[m.jobKey] && vm.job[m.jobKey].phone);

                    buildPhones(vm.data[m.tenantKey], response, prevPhone);

                    vm[m.isTenantFlag] = true;
                    vm.data[m.personKey] = null;

                    vm.data[m.tenantKey].name = selected.name;

                    // Clear user selection when tenant is chosen
                    if (vm[m.selectedUserModel]) {
                        vm[m.selectedUserModel].selected = null;
                    }
                    delete vm.data._links[m.linkUser];

                    if (!isInit) {
                        vm.selectAsOccupier(type);
                    }
                }));
            } else {
                vm[m.isTenantFlag] = false;
                if (vm[m.selectedRelationshipModel]) {
                    vm[m.selectedRelationshipModel].selected = null;
                }
                delete vm.data._links[m.linkTenant];
                vm.data[m.tenantKey] = null;
                return $q.when();
            }
        }

        function toggleManualEntryGeneric(type) {
            const m = entityMeta[type];
            const manual = vm[type + 'ManualEntry'];

            vm[m.selectedUserModel].required = !manual;
            vm[m.selectedTenantModel].required = !manual;

            if (manual) {
                if (vm[m.selectedUserModel]) {
                    vm[m.selectedUserModel].selected = null;
                    vm[m.selectedUserModel].disabled = true;
                    // Trigger change handler to clear related state
                    if (type === 'reporter') {
                        vm.reporterChangeUser();
                    } else {
                        vm.contactChangeUser();
                    }
                }

                if (vm[m.selectedTenantModel]) {
                    vm[m.selectedTenantModel].selected = null;
                    vm[m.selectedTenantModel].disabled = true;
                }

                vm[m.isTenantFlag] = false;
                if (vm.data && vm.data._links) {
                    delete vm.data._links[m.linkTenant];
                    delete vm.data._links[m.linkUser];
                }

                vm.data[m.tenantKey] = null;
            } else {
                if (vm[m.selectedUserModel]) {
                    vm[m.selectedUserModel].disabled = false;
                }

                if (vm[m.selectedTenantModel]) {
                    vm[m.selectedTenantModel].disabled = false;
                }

                if (vm.data && vm.data[m.personKey]) {
                    vm.data[m.personKey].name = null;
                    vm.data[m.personKey].email = null;
                    vm.data[m.personKey].phone = null;
                }
            }
        }

        function extractApprovalDocTypes(docTypes) {
            var result = [];
            angular.forEach(docTypes, function(docType) {
                if (docType.approvalRequired) {
                    result.push(docType.id);
                }
            });

            return result;
        }

        function setsAreEqual(set1, set2) {
            if (set1.length !== set2.length) {
                return false;
            }

            for (const documentType of set1) {
                if (!set2.includes(documentType)) {
                    return false;
                }
            }

            return true;
        }

        function submitAction() {
            var approvalDocTypes =  extractApprovalDocTypes(vm.selectedRequiredDocumentTypes);
            if (setsAreEqual(approvalDocTypes, vm.originalApprovalDocTypes)) {
                return doSubmit();
            }

            var config = {
                bodyMessage: null,
                htmlBodyMessage: $translate.instant('JOB_WORKFLOW_EDIT_JOB_DOCS_CONFIRMATION')
            }
            return confirmationModal.open(config).result.then(function() {
                doSubmit();
            });
        }

        function applyNotifications() {
            var targets = {
                reporter: [vm.data.reporter, vm.data.reporterTenant],
                contact: [vm.data.siteContact, vm.data.contactTenant]
            };

            angular.forEach(targets, function(entities, type) {
                angular.forEach(entities, function(entity) {
                    if (entity) {
                        entity.notifyOnCreate = vm.notifications[type].notifyOnCreate;
                        entity.notifyOnComplete = vm.notifications[type].notifyOnComplete;
                    }
                });
            });
        }

        function doSubmit() {
            applyNotifications();

            vm.data.requiredDocumentTypes.links = [];
            angular.forEach(vm.selectedRequiredDocumentTypes, function(value) {
                vm.data.requiredDocumentTypes.links.push({
                    href: value._links.self.href
                });
            });

            if (vm.data._links.hasOwnProperty('statutorytype') && (!vm.data._links.statutorytype || vm.data._links.statutorytype.href === null)) {
                delete vm.data._links.statutorytype;
            }
            if (vm.data._links.hasOwnProperty('reporter') && (!vm.data._links.jobgroup || vm.data._links.jobgroup.href === null)) {
                delete vm.data._links.reporter;
            }
            if (vm.data._links.hasOwnProperty('contact') && (!vm.data._links.jobgroup || vm.data._links.jobgroup.href === null)) {
                delete vm.data._links.contact;
            }
            if (vm.data._links.hasOwnProperty('reporter') && vm.data._links.reporter == null) {
                delete vm.data._links.reporter;
            }
            if (vm.data._links.hasOwnProperty('contact') && vm.data._links.contact == null) {
                delete vm.data._links.contact;
            }

            if (vm.data._links.hasOwnProperty('reporterTenant') && vm.data._links.reporterTenant === null) {
                delete vm.data._links.reporterTenant;
            }

            if (vm.data._links.hasOwnProperty('contactTenant') && vm.data._links.contactTenant === null) {
                delete vm.data._links.contactTenant;
            }

            if (lodash.has( vm.selectedJobGroupModel,'href')) {
                vm.data._links.jobgroup = vm.selectedJobGroupModel;
            } else if (lodash.has( vm.selectedJobGroupModel,'selected')) {
                vm.data._links.jobgroup = vm.selectedJobGroupModel.selected;
            } else {
                delete vm.data._links.jobgroup;
            }

            if (vm.selectedRequiredDocumentTypeModel.selected) {
                vm.data._links.requiredDocumentType = {href: vm.selectedRequiredDocumentTypeModel.selected.href};
            }

            angular.forEach(vm.data._links, function(value, key) {
                if (!angular.isObject(vm.data._links[key])) {
                    vm.data._links[key] = {
                        href: value
                    };
                }
            });

            return apiClient.update(vm.job.getLink('edit-job'), vm.data).then(function(response) {
                if (response) {
                    return $state.go('^.^', {}, {reload: $state.get('^.^.^')}).then(function() {
                        messenger.success(vm.translation + '_SUCCESS');
                    });
                }
            });
        }

        function changeChargeType() {
            if (vm.selectedChargeTypeModel.selected) {
                vm.data._links.chargetype = vm.selectedChargeTypeModel.selected.href;
            } else {
                vm.data._links.chargetype = null;
            }
        }

    }
})();
